module.exports = __webpack_public_path__ + "img/governador.47b072ad.png";